import { useEffect, useState, type FormEvent } from "react";
import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type Ponderacion } from "@/lib/api";
import { aPayloadPorDefecto, escalaAltura, formPorDefecto, validarPorDefecto, type CampoPorDefecto, type FormPorDefecto } from "@/lib/ponderacion";

/** Lógica de Configuración → Ponderación (sin JSX): los multiplicadores por defecto de los deptos y el coef. altura estándar. */
export function usePonderacionPorDefectoTab() {
  const { fid } = useContextoApp();
  const ruta = `/api/fideicomisos/${fid}/unidades/ponderacion`;
  const recurso = useApiResource<Ponderacion>(ruta);
  const [form, setForm] = useState<FormPorDefecto | null>(null);
  const [intentado, setIntentado] = useState(false);
  const [guardado, setGuardado] = useState(false);
  const accion = useAsyncAction((cuerpo: ReturnType<typeof aPayloadPorDefecto>) => api.put<Ponderacion>(`${ruta}/por-defecto`, cuerpo));

  useEffect(() => {
    if (recurso.data) setForm(formPorDefecto(recurso.data));
  }, [recurso.data]);

  const errores = form ? validarPorDefecto(form) : {};
  const pisosConDeptos = [...new Set((recurso.data?.departamentos ?? []).map((d) => d.piso))].sort((a, b) => a - b);

  const guardar = async (e: FormEvent) => {
    e.preventDefault();
    setIntentado(true);
    if (!form || Object.keys(errores).length > 0) return;
    const actualizada = await accion.run(aPayloadPorDefecto(form));
    if (actualizada) {
      setForm(formPorDefecto(actualizada));
      setIntentado(false);
      setGuardado(true);
    }
  };

  return {
    cargando: form === null && recurso.loading,
    errorCarga: form === null ? (recurso.error?.message ?? null) : null,
    reintentar: recurso.recargar,
    form,
    escala: form ? escalaAltura(form, pisosConDeptos) : null, // "1° 0,92 · 2° 0,95 · …" en vivo
    cambiar: (campo: CampoPorDefecto, valor: string) => {
      setForm((f) => (f ? { ...f, [campo]: valor } : f));
      setGuardado(false);
    },
    errores: intentado ? errores : {},
    guardar,
    guardando: accion.loading,
    error: accion.error,
    guardado,
  };
}
